import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

export function askHeidiOpened() {
  trackLegacyEvent({
    name: SegmentObjectName.AskAi,
    props: {
      action: SegmentActionName.AskHeidiOpened,
    },
  });
  // V2 — Amplitude migration (askHeidiOpened -> panel_opened)
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.PanelOpened,
    props: {
      panel_type: 'ask_heidi',
      trigger: 'manual',
    },
  });
}
